export default __webpack_public_path__ + "static/media/layout3.119d4ba8.svg";